import { mapById } from '@dmp/shared/helpers';
import { coreQuestionResourceListToState } from '../../../transformers/core-question-list-resource-to-state';
import type { StoreState } from '../../state-types';
import { getCoreQuestion } from './get-core-question';

/**
 * Switching editing core question for the editing form
 * - Copy and convert the core question config to card and answer atoms.
 * - Passing THE SAME ID will reset the current question's form to its original config.
 */
export const switchEditingCoreQuestion =
    (nextId: string) =>
    (state: StoreState): StoreState => {
        const nextCoreQuestion = getCoreQuestion(nextId)(state);

        if (!nextCoreQuestion) {
            throw new Error(
                `Unable to pull Core Question Resource ${nextId} from state.`
            );
        }

        const { questions, answers } = coreQuestionResourceListToState([
            nextCoreQuestion,
        ]);

        return {
            ...state,
            // replace all cards and answers to converted core questions above
            cards: mapById(questions),
            answers: mapById(answers),
            // update ui form
            uiCoreQuestionForm: {
                // set pristine
                isDirty: false,
                // set form isActive state from the resource
                isActive: nextCoreQuestion.attributes.isActive,
            },
        };
    };
